




































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import { ValidationObserver } from "vee-validate";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import HasValidation from "@/mixins/HasValidation";
import Context from "@/mixins/context";

// Enums
import { DataModules } from "@/store/modules/data";
import { ActionTypes } from "@/data/enums";

// Types
import { IClient, IClientEmailForm } from "@/models/clients";
import { IState } from "@/store";
import { IEmail } from "@/models/emails";

@Component({
  computed: {
    ...mapState({
      dataScope(state: IState, getters) {
        return getters[`data/${this.dataModule}/clientScope`](this.clientId);
      },
      params(state: IState, getters) {
        return getters[`data/${this.dataModule}/params`](this.clientId);
      },
      selectorDataScope(state: IState, getters) {
        return getters[`data/${this.dataModule}/selectorScope`](this.clientId);
      },
      selectorParams(state: IState, getters) {
        return getters[`data/${this.dataModule}/selectorParams`](this.clientId);
      }
    })
  }
})
export default class AddEditClientEmailsModal extends Mixins(
  RequestPromises,
  HasValidation,
  Context
) {
  public $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
    email: HTMLFormElement;
  };

  public dataScope!: string;
  public params!: object;
  public selectorDataScope!: string;
  public selectorParams!: object;

  @Prop({ default: null })
  public data: any;

  @Prop({ default: "" })
  public emailId!: IEmail["id"];

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ default: ActionTypes.CREATE })
  public actionType!: string;

  public form: IClientEmailForm = {
    email: null,
    type: 1
  };
  public formClone = {} as IClientEmailForm;

  public dataModule: string = DataModules.CLIENTS_EMAILS;

  public isLoading = true;
  public isProcessing = false;

  public created() {
    if (this.actionType !== ActionTypes.CREATE) {
      this.form = this.$_.merge(this.form, this.data);
      this.formClone = this.$_.cloneDeep(this.form);
    }
    this.isLoading = false;
  }

  public mounted() {
    this.$nextTick(() => {
      if (!this.$refs.email) {
        return;
      }
      this.$refs.email.focus();
    });
  }

  public get formIsValid() {
    let allFieldsValid = true;

    if (this.actionType === ActionTypes.CREATE) {
      if (this.$_.isEmpty(this.form.email)) {
        allFieldsValid = false;
      }
    } else if (this.$_.isEqual(this.form, this.formClone)) {
      allFieldsValid = false;
    }

    return allFieldsValid;
  }

  private get formIsDisabled() {
    return (
      this.isProcessing || !this.formIsValid || this.hasErrors || this.isLoading
    );
  }

  public validateBeforeSubmit() {
    this.isProcessing = true;
    this.validate()
      .then(result => {
        if (result) {
          if (this.actionType === ActionTypes.CREATE) {
            return this.createEmail();
          }

          return this.updateEmail();
        }
        throw this.$t("_sentence.form_is_not_valid");
      })

      .then(async (email: IEmail) => {
        await this.refreshLists();
        this.$buefy.toast.open({
          message: this.$t(
            `_.object_successfully_${
              this.actionType === ActionTypes.CREATE ? "added" : "updated"
            }`,
            { object: this.$t("_.email") }
          ) as string
        });
        this.$emit("success", email);
        this.$emit("close");
      })
      .catch(error => {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      })
      .finally(() => {
        this.isProcessing = false;
      });
  }

  public createEmail() {
    return this.$store.dispatch(`data/${this.dataModule}/create`, {
      id: this.clientId,
      data: this.form
    });
  }

  public updateEmail() {
    return this.$store.dispatch(`data/${this.dataModule}/update`, {
      id: this.clientId,
      email_id: this.emailId,
      data: this.getNewValues()
    });
  }

  public getNewValues() {
    const newValues: any = this.$_.omitBy(this.form, (v, k) => {
      return this.formClone[k] === v;
    });

    newValues.verified = 0;
    return newValues;
  }

  public async refreshLists() {
    if (!this.$_.isEmpty(this.params)) {
      await this.$store.dispatch(`data/${this.dataModule}/list`, {
        id: this.clientId,
        params: this.params,
        scope: this.dataScope,
        ignoreStored: true,
        vm: this
      });

      await this.$store.dispatch("data/binList", {
        storeModule: this.dataModule,
        scope: this.dataScope,
        vm: this
      });
    }

    if (!this.$_.isEmpty(this.selectorParams)) {
      await this.$store.dispatch(`data/${this.dataModule}/list`, {
        id: this.clientId,
        params: this.selectorParams,
        scope: this.selectorDataScope,
        ignoreStored: true,
        vm: this
      });

      await this.$store.dispatch("data/binList", {
        storeModule: this.dataModule,
        scope: this.selectorDataScope,
        vm: this
      });
    }
  }
}
